import React from 'react';
import CustomText from './CustomText';
import SvgIconButton from './SvgIconButton';

export const Footer = ({ theme }) => {
  const footer = {
    backgroundColor: theme.primaryColor,
    minHeight: 100,
    paddingTop: 20,
    paddingBottom: 20,
  };

  const socialMediaIconSize = theme.isMobile ? 30 : 30;
  const socialMediaIconSpace = theme.isMobile ? 20 : 20;

  return (
    <div style={footer}>
      <div className='container'>
        <div className='row'>
          <div className='col-6'>
            <div>
              <CustomText
                fontSize={24}
                fontWeight={700}
                color={theme.lighterColor}
              >
                Sachintha
              </CustomText>
            </div>
            <div>
              <CustomText
                fontSize={16}
                fontWeight={400}
                color={theme.lighterColor}
              >
                Senior Software Engineer
              </CustomText>
            </div>
          </div>
          <div className='col-6'>
            <div className='text-end'>
              <SvgIconButton
                icon='M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z'
                color={theme.lighterColor}
                width={socialMediaIconSize}
                height={socialMediaIconSize}
                marginRight={socialMediaIconSpace}
              />
              <SvgIconButton
                icon='M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85C10.44 7.34 11.93 5.96 14.22 5.96C15.31 5.96 16.45 6.15 16.45 6.15V8.62H15.19C13.95 8.62 13.56 9.39 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96A10 10 0 0 0 22 12.06C22 6.53 17.5 2.04 12 2.04Z'
                color={theme.lighterColor}
                width={socialMediaIconSize}
                height={socialMediaIconSize}
                marginRight={socialMediaIconSpace}
              />
              <SvgIconButton
                icon='M14.829 6.302c-.738-.034-.96-.04-2.829-.04s-2.09.007-2.828.04c-1.899.087-2.783.986-2.87 2.87-.033.738-.041.959-.041 2.828s.008 2.09.041 2.829c.087 1.879.967 2.783 2.87 2.87.737.033.959.041 2.828.041 1.87 0 2.091-.007 2.829-.041 1.899-.086 2.782-.988 2.87-2.87.033-.738.04-.96.04-2.829s-.007-2.09-.04-2.828c-.088-1.883-.973-2.783-2.87-2.87zm-2.829 9.293c-1.985 0-3.595-1.609-3.595-3.595 0-1.985 1.61-3.594 3.595-3.594s3.595 1.609 3.595 3.594c0 1.985-1.61 3.595-3.595 3.595zm3.737-6.491c-.464 0-.84-.376-.84-.84 0-.464.376-.84.84-.84.464 0 .84.376.84.84 0 .463-.376.84-.84.84zm-1.404 2.896c0 1.289-1.045 2.333-2.333 2.333s-2.333-1.044-2.333-2.333c0-1.289 1.045-2.333 2.333-2.333s2.333 1.044 2.333 2.333zm-2.333-12c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6.958 14.886c-.115 2.545-1.532 3.955-4.071 4.072-.747.034-.986.042-2.887.042s-2.139-.008-2.886-.042c-2.544-.117-3.955-1.529-4.072-4.072-.034-.746-.042-.985-.042-2.886 0-1.901.008-2.139.042-2.886.117-2.544 1.529-3.955 4.072-4.071.747-.035.985-.043 2.886-.043s2.14.008 2.887.043c2.545.117 3.957 1.532 4.071 4.071.034.747.042.985.042 2.886 0 1.901-.008 2.14-.042 2.886z'
                color={theme.lighterColor}
                width={socialMediaIconSize}
                height={socialMediaIconSize}
              />
            </div>
          </div>
        </div>
        <div className='row text-center' style={{ marginTop: 10 }}>
          <CustomText fontSize={15} fontWeight={400} color={theme.lighterColor}>
            &copy; All rights reserved.
          </CustomText>
        </div>
      </div>
    </div>
  );
};
